const InvoiceActionTypes = {
  SELECT_VIEW: 'SELECT_VIEW',
};

export default InvoiceActionTypes;
